import type { Ref } from 'vue';
import type { HekateDisplayForm } from '@onshape/www-inertia';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import UnifiedSignupIntent from '../session-info/UnifiedSignupIntent';
import AbstractCheckErrorSignupScreen from './AbstractCheckErrorSignupScreen';
import type UnifiedSignupSessionInfo from '../session-info/UnifiedSignupSessionInfo';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';

export default class EmailCheck401SignupScreen extends AbstractCheckErrorSignupScreen {
  public screenName: UnifiedSignupScreenName = 'uss-email-check-401';

  private isEduRenew: boolean;

  private isProUpgrade: boolean;

  constructor({
    sessionInfo,
    formDefinition,
    isBackButtonHidden,
  }: {
    sessionInfo: Ref<UnifiedSignupSessionInfo>;
    formDefinition: Ref<HekateDisplayForm>;
    isBackButtonHidden: Ref<boolean>;
  }) {
    super({ sessionInfo, formDefinition, isBackButtonHidden });
    this.isEduRenew = false;
    this.isProUpgrade = false;
  }

  public predicate(): boolean {
    const { emailCheckCode } = this.sessionInfo.value;
    if (
      emailCheckCode !== 401 ||
      this.sessionInfo.value.isEduRenew ||
      this.sessionInfo.value.isProUpgrade
    ) {
      return false;
    }
    return true;
  }

  public override async toNextScreen(): Promise<boolean> {
    if (this.isEduRenew) {
      this.sessionInfo.value.intent = UnifiedSignupIntent.eduIntent;
      this.sessionInfo.value.isEduRenew = true;
    }

    if (this.isProUpgrade) {
      this.sessionInfo.value.isProUpgrade = true;
      this.sessionInfo.value.startScreen = UnifiedSignupStartScreen.trialPlan;
    }
    return true;
  }

  public setEduRenew() {
    this.isEduRenew = true;
  }

  public setProUpgrade() {
    this.isProUpgrade = true;
  }
}
